<template>
  <div class="my-2" data-test="paymentStatus">
    <template
      v-if="
        item.event.useOnlinePayments &&
        !actions.allEntriesExternal(item.entries)
      "
    >
      <AppShowPaymentStatus
        v-if="actions.allPaid(item.entries, item.registrationEventProducts)"
        :status="'PAID'"
        tag="span"
      />
      <template
        v-else-if="
          $allowedMutation(
            item.registrantPerson.allowedMutations,
            'paymentInitiate'
          )
        "
      >
        <v-btn
          v-if="$vuetify.display.lgAndUp"
          :to="{
            name: 'Payables',
            params: { personId: item.registrantPerson.id }
          }"
          color="accent"
          data-test="eventPurchase"
          class="text-center register-btn"
          style="width: 132px"
        >
          <div class="d-flex" style="flex-direction: column">
            {{ $t("events:common.purchase.button") }}
            <small style="font-weight: normal">
              {{ $t("events:common.PurchasePayBefore.text") }}
              {{ $dayjs.date(item.earliestPaymentDeadline) }}
            </small>
          </div>
        </v-btn>
        <v-btn
          v-else
          :to="{
            name: 'Payables',
            params: { personId: item.registrantPerson.id }
          }"
          icon
          variant="text"
        >
          <v-icon>$iconCart</v-icon>
        </v-btn>
      </template>
      <AppShowPaymentStatus
        v-else
        tag="span"
        :center="false"
        :status="'NOT_PAID'"
      />
    </template>
    <AppShowOfficePurchase
      v-else-if="actions.allEntriesExternal(item.entries)"
    />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import AppShowPaymentStatus from "@/components/elements/AppShows/AppShowPaymentStatus.vue";
import AppShowOfficePurchase from "@AppShows/event/AppShowOfficePurchase.vue";

export default defineComponent({
  name: "UpcomingRegistrationPaymentStatus",
  components: {
    AppShowPaymentStatus,
    AppShowOfficePurchase
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    actions: {
      type: Object,
      required: true
    }
  }
});
</script>
